module.exports = __webpack_public_path__ + "static/Joao-Mozart-ad69df8ba1acb39cf1eb13a8fc7eefc3.jpg";